export const INCREMENT_NOTIFICATION_BADGE = 'INCREMENT_NOTIFICATION_BADGE';
export const RESET_NOTIFICATION_BADGE = 'RESET_NOTIFICATION_BADGE';

export const incrementNotificationBadge = () => ({ type: INCREMENT_NOTIFICATION_BADGE });

export const resetNotificationBadge = () => ({ type: RESET_NOTIFICATION_BADGE });
